import languages from './langs';
import countriesDe from './countries.de';
import countriesEn from './countries.en';

const countries = {
  en: countriesEn,
  de: countriesDe,
};

export { languages, countries };
